import React from "react";
import { CategoryDetails } from "../lib/types";
import { Link } from "react-router-dom";

function Category({ productdetail }: { productdetail: CategoryDetails }) {
  const handleClick = () => {
    window.scrollTo(0, 0);
  };
  return (
    <div className="bg-[#F1F1F1] flex flex-col justify-center md:h-[150px] relative items-center rounded-lg p-4">
      <div className="absolute grid place-items-center -top-12 md:-top-14">
        <img src={productdetail.img} alt="" className="w-[90px] md:w-[120px]" />
        <div className="bg-black h-[10px] blur-md w-1/12 p-2 absolute bottom-0"></div>
      </div>
      <div className="mt-8 md:mt-10 flex flex-col items-center justify-center gap-1 md:gap-3">
        <p className="text-base font-bold uppercase tracking-wide">
          {productdetail.title}
        </p>
        <Link
          to={`category/${productdetail.title}`}
          onClick={handleClick}
          className="flex items-center st gap-2 cursor-pointer"
        >
          <p className="text-xs tst uppercase text-gray-600/50 tracking-wide font-extrabold">
            Shop
          </p>
          <i className="fa-solid tsi fa-chevron-right !text-xs !text-primary"></i>
        </Link>
      </div>
    </div>
  );
}

export default Category;
